/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Back_HomeInputs */

const en_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Home`)
};

const de_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Startseite`)
};

const fr_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour a l'accueil`)
};

const es_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio`)
};

const it_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla home`)
};

const nl_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar home`)
};

const pl_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstecz do strony glownej`)
};

const fi_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin etusivulle`)
};

const da_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til forsiden`)
};

const sv_a11y_statement_back_home = /** @type {(inputs: A11y_Statement_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till startsidan`)
};

/**
* | output |
* | --- |
* | "Back to Home" |
*
* @param {A11y_Statement_Back_HomeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_back_home = /** @type {((inputs?: A11y_Statement_Back_HomeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Back_HomeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_back_home(inputs)
	if (locale === "fr") return fr_a11y_statement_back_home(inputs)
	if (locale === "es") return es_a11y_statement_back_home(inputs)
	if (locale === "it") return it_a11y_statement_back_home(inputs)
	if (locale === "nl") return nl_a11y_statement_back_home(inputs)
	if (locale === "pl") return pl_a11y_statement_back_home(inputs)
	if (locale === "fi") return fi_a11y_statement_back_home(inputs)
	if (locale === "da") return da_a11y_statement_back_home(inputs)
	if (locale === "sv") return sv_a11y_statement_back_home(inputs)
	return en_a11y_statement_back_home(inputs)
});